export default "__VITE_ASSET__CRMD2Tn9__"